import { createSlice } from '@reduxjs/toolkit'

// Local/derived UI state only — server data lives in growthosBrandsApiSlice's
// RTK Query cache (never persisted, see store.js's blacklist). No more page/size —
// the list endpoint now returns everything unfiltered, matching the real app;
// filtering/pagination-free bucketing happens client-side on BrandsPage.
const initialState = {
  filters: { segment: '', salesPocId: '', from: '', to: '' },
  formDialogOpen: false,
  editingBrandId: null, // null => create mode
}

const growthosBrandsSlice = createSlice({
  name: 'growthosBrands',
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload }
    },
    openCreateDialog(state) {
      state.formDialogOpen = true
      state.editingBrandId = null
    },
    openEditDialog(state, action) {
      state.formDialogOpen = true
      state.editingBrandId = action.payload
    },
    closeFormDialog(state) {
      state.formDialogOpen = false
      state.editingBrandId = null
    },
  },
})

export const {
  setFilters,
  openCreateDialog,
  openEditDialog,
  closeFormDialog,
} = growthosBrandsSlice.actions

export default growthosBrandsSlice.reducer
